import { render, staticRenderFns } from "./UkStep1.vue?vue&type=template&id=37c48948&scoped=true&lang=tr"
import script from "./UkStep1.vue?vue&type=script&lang=js"
export * from "./UkStep1.vue?vue&type=script&lang=js"
import style1 from "./UkStep1.vue?vue&type=style&index=1&id=37c48948&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c48948",
  null
  
)

export default component.exports